import type { BereichsauswahlOption, Wert } from "@/lib/models/globalerFilterApi";

// Daten, die der Browser bei sich behält

export const UntergruppeEigenschaftName = "ug";

export interface EigenschaftFilterAuswahlBereichsauswahl {
	Name: string;
	NamePraefix?: string;
	Bereichsauswahl: true;

	Min: number | null;
	Max: number | null;
	BereichsauswahlCheckbox: string | string[] | null;
	BereichsauswahlOption?: BereichsauswahlOption;
}

export interface EigenschaftFilterAuswahlEinfacherWert {
	Name: string;
	NamePraefix?: string;
	Bereichsauswahl: false;

	Werte: Wert[];
}

export interface EigenschaftFilterAuswahlUntergruppe {
	Name: typeof UntergruppeEigenschaftName,
	NamePraefix?: string;
	Bereichsauswahl: false,

	Werte: string[];
}

export type EigenschaftFilterAuswahl = EigenschaftFilterAuswahlBereichsauswahl | EigenschaftFilterAuswahlEinfacherWert | EigenschaftFilterAuswahlUntergruppe;

export interface UiNormblattUebersicht {
	uebersicht: JQuery<HTMLElement>;
	normblaetter: UiNormblatt[];
	ueberschrift: JQuery<HTMLHeadingElement>;
}

export interface UiNormblatt {
	normblatt: JQuery<HTMLElement>;
	normblattGuid: string;
	gueltigeFilterKombinationen: string;
	istKimNorm: boolean;

	// nur bei non-KIM Normen
	normblattLinks?: JQuery<HTMLAnchorElement>;
	normblattUrl?: string;
}
